import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import GoyanesNavbar from './modules/app/Navbar';
import Bienvenida from './modules/app/Bienvenida';
import Footer from './modules/app/Footer';
import UnionEuropea from './modules/union_europea/UnionEuropea';
import XuntaGalicia from './modules/xunta_galicia/XuntaGalicia';
import Empresa from './modules/app/Empresa';
import Contacto from './modules/app/Contacto';
import { useEffect } from 'react';

function RedirectCatalogo() {
  useEffect(() => {
    window.location.href = 'https://goyanesonline.com';
  }, []);

  return null;
}


function App({store}) {
  return (
    <Router>
      <div>
      <GoyanesNavbar/>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Routes>
          <Route path="/"
          element={<Bienvenida/>}>
          </Route>
          <Route path="/empresa" element={<Empresa/>}/>
          <Route path="/union-europea" element={<UnionEuropea/>}/>
          <Route path="/xunta-galicia" element={<XuntaGalicia/>}/>
          <Route path="/contacto" element={<Contacto/>}/>
          <Route path="/catalogo" element={<RedirectCatalogo />} />
        </Routes>
      </div>
      <Footer/>
    </Router>
  );
}

export default App;
